import { CommonCareersAndCelebrityInterface } from 'types/componentTypes';

export interface CareersAndCelebrityInterface
  extends CommonCareersAndCelebrityInterface {}

export enum CareersAndCelebritySlug {
  CELEBRITY = 'celebrity',
  CARRERS = 'careers',
}
